import React, { Component } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import settings from "./../settings.js";

class Notification extends Component {
  constructor(props) {
    super(props);
    this.state = { modal: false, isLoading: false, data: [] };
    this.toggle = this.toggle.bind(this);
  }
  loadNewsDetails() {
    const notification = this.props.notification;

    fetch(
      settings.server_url +
        "get_newsitem/" +
        window.sessionStorage.getItem("sid") +
        "/" +
        notification.nieuws_id
    )
      .then((res) => res.json())
      .then((response) => {
        this.setState({ data: response, isLoading: false });
      })
      .catch((error) => console.error("Error:", error));
  }
  clickRemove = (e, index) => {
    this.setState({
      modal: false,
    });
    this.props.clickRemoveHandler(e, index);
  };
  toggle() {
    if (!this.state.modal) {
      this.loadNewsDetails();
    }
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }
  decodeHtmlEntities(txt = "") {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = txt;
    return textarea.value;
  }
  createMarkup(txt) {
    return { __html: this.decodeHtmlEntities(txt || "") };
  }
  render() {
    const notification = this.props.notification;

    let cls = "notification";
    if (notification.removed) {
      cls += " removed";
    }
    if (this.props.openNotification) {
      cls += " withModal";
    }
    if (notification.read === "0") {
      cls += " unread";
    }
    return (
      <div
        className={cls}
        key={notification.nieuws_id}
        onClick={() => this.props.openNotification && this.toggle()}>
        <div className="notificationTitle">{notification.nieuws_title}</div>
        {notification.nieuws_body && (
          <div className="notificationBody">{notification.nieuws_body}</div>
        )}

        {this.props.openNotification && (
          <Modal
            isOpen={this.state.modal}
            toggle={this.toggle}
            className={this.props.className}>
            <ModalHeader toggle={this.toggle}>
              {notification.nieuws_title}
            </ModalHeader>
            <ModalBody
              dangerouslySetInnerHTML={this.createMarkup(
                (this.state.data && this.state.data.nieuws_body) ||
                  notification.nieuws_body ||
                  ""
              )}
            />
            <ModalFooter>
              <Button color="danger" onClick={this.clickRemove}>
                Bericht gelezen
              </Button>
              <Button color="secondary" onClick={this.toggle}>
                Sluiten
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </div>
    );
  }
}

export default Notification;
